export interface LaunchApplicationOptions {
  /**
     * 要拉起的移动应用的 appid，注册在 open.wexin.qq.com 网站上, jssdk模式下必须使用的参数
     *
     * 传入appID后默认使用jssdk模式，如果不传入appID则使用jsbridge模式
     *
     */
  appID?: string;
  /**
     * 填写拉起链接
     *
     * Android使用此参数，第三方应用自定义简单数据，微信终端会回传给第三方应用处理
     * jssdk模式下可以结合appID使用该参数
     */
  extInfo?: string;
  /**
     *
     * iOS使用此参数，微信会讲appID参数与之组合成: appid://parameter 传给系统，第三方应用可将appID注册为自己的 scheme
     * 前缀，然后再 applicationHandleOpenUrl 回调中读取 parameter。Jssdk模式下结合appID使用该参数
     */
  parameter?: string;
  /**
     * jsbridge 模式下，只需使用这个字段
     */
  schemeUrl?: string;
}

export function launchByWxSDK(options: LaunchApplicationOptions): Promise<boolean> {
  return new Promise((resolve, reject) => {
    if (!window.WeixinJSBridge) {
      reject('coudn\'t access WeixinJSBridge');
      return;
    }

    window.WeixinJSBridge.invoke('launchApplication', options, (res) => {
      if (res.err_msg === 'launchApplication:ok') {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  });
}
